import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchDailyWholesale = createAsyncThunk(
  "api/dailyWholesale/fetch",
  async (
    {
      fromDate,
      toDate,
      user_ids = [],
      partner_ids = [],
      product_ids = [],
      group_by = "all", // group by: all - daily - weekly - monthly - yearly
      valueType = "total", // value Type: total - tax - withTax
      viewType = "all", // value Type: all - customers - item - salesman
    },
    thunkAPI
  ) => {
    try {
      const requestData = {
        fromdate: fromDate,
        todate: toDate,
        user_ids,
        partner_ids,
        product_ids,
        group_by,
        valueType,
        viewType,
      };

      const response = await api.post(`/api/DailyWholesale`, requestData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const dailyWholesaleSlice = createSlice({
  name: "dailyWholesale",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyWholesale.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDailyWholesale.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload;
      })
      .addCase(fetchDailyWholesale.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default dailyWholesaleSlice.reducer;

// Selectors
export const selectDailyWholesaleRows = (state) => state.dailyWholesale.rows;
export const selectDailyWholesaleStatus = (state) =>
  state.dailyWholesale.status;
export const selectDailyWholesaleError = (state) => state.dailyWholesale.error;
